"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTime = void 0;
var React = __importStar(require("react"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var TimeOptions_1 = __importDefault(require("../TimeOptions/TimeOptions"));
var Input_1 = __importDefault(require("../../Input/Input"));
var Calendar_1 = __importDefault(require("../Calendar/Calendar"));
var reserveSpace_1 = __importDefault(require("../../../utils/reserveSpace"));
var react_1 = require("react");
var localization_1 = require("@scuf/localization");
var ig_utils_1 = require("../ig_utils");
var DateTime = /** @class */ (function (_super) {
    __extends(DateTime, _super);
    function DateTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            openUp: false,
            formattedDate: '',
            formattedTime: '',
            month: moment_timezone_1.default(),
            value: undefined,
            dateSelected: false,
            timeSelected: false,
            focused: false,
            prevValue: undefined,
            dateFormat: '',
            timeFormat: '',
            datePlaceholder: '',
            timePlaceholder: ''
        };
        _this.shimLocals = ig_utils_1.shimLocals;
        _this.genFormat = ig_utils_1.genFormat(_this.props.lng, _this.props.displayFormat);
        _this.getMonth = ig_utils_1.getMonth;
        _this.updateValue = ig_utils_1.updateValue;
        _this.genClasses = ig_utils_1.genClasses;
        _this.handleSelection = ig_utils_1.handleSelection;
        _this.moment = ig_utils_1.configMoment(_this.props.lng, _this.props.timezone, _this.props.displayFormat);
        _this.validateTime = ig_utils_1.validateTime;
        _this.validateDate = ig_utils_1.validateDate;
        _this.captureClick = function (e) {
            if (_this.props.disabled)
                return;
            var dom = e.target;
            var closeOnDocumentClick = _this.props.closeOnDocumentClick;
            if (!_this.menuRef.contains(dom) && closeOnDocumentClick) {
                _this.setState({ open: false });
            }
            if (_this.menuRef.contains(dom)) {
                _this.setState({ open: true });
            }
        };
        _this.handleFocus = function () {
            if (_this.props.disabled)
                return;
            _this.setState({ open: true, openUp: false, focused: true }, function () {
                var rect = _this.overRef.getBoundingClientRect();
                var direction = rect.bottom >= (window.innerHeight || document.documentElement.clientHeight);
                _this.setState({ openUp: direction });
            });
        };
        _this.handleBlur = function () {
            _this.setState({ focused: false });
        };
        _this.genPlaceholder = function (dateFormat) {
            var placeholder = _this.props.placeholder;
            var placeholders = (placeholder && placeholder.split(',')) || [];
            var defaultTimeFormat = 'H:MM';
            switch (placeholders.length) {
                case 1:
                    placeholders.push(defaultTimeFormat);
                    break;
                case 2:
                    placeholders.splice(1, 1, placeholders[1].trim());
                    break;
                default:
                    placeholders = [dateFormat, defaultTimeFormat];
                    break;
            }
            return { datePlaceholder: placeholders[0], timePlaceholder: placeholders[1] };
        };
        _this.handleUpdate = function (_a) {
            var action = _a.action, payload = _a.payload;
            var value = _this.state.value;
            var _b = _this.props, onChange = _b.onChange, onTextChange = _b.onTextChange, time = _b.time, closeOnSelection = _b.closeOnSelection;
            var date = payload.date, error = payload.error, text = payload.text;
            var _c = _this.genFormat(date), formattedFull = _c.formattedFull, formattedDate = _c.formattedDate, formattedTime = _c.formattedTime;
            var close = {
                dateSelected: false,
                timeSelected: false,
                open: closeOnSelection ? false : true
            };
            var newValue;
            switch (action) {
                case 'next':
                    _this.setState({ month: date });
                    break;
                case 'previous':
                    _this.setState({ month: date });
                    break;
                case 'goToToday':
                    _this.setState({ month: date });
                    break;
                case 'selectDay':
                    newValue = _this.updateValue({ value: value, date: date, unit: 'day' });
                    _this.setState(function (_a) {
                        var timeSelected = _a.timeSelected;
                        var open = {
                            formattedDate: formattedDate,
                            value: newValue,
                            dateSelected: true,
                            month: _this.getMonth(date)
                        };
                        var shut = !time || timeSelected;
                        return __assign(__assign({}, open), (shut && close));
                    }, function () {
                        _this.handleSelection({
                            onChange: onChange,
                            onTextChange: onTextChange,
                            error: error,
                            text: formattedFull,
                            date: _this.moment(newValue)
                        });
                    });
                    break;
                case 'selectTime':
                    newValue = _this.updateValue({ value: value, date: date, unit: 'time' });
                    _this.setState(function (_a) {
                        var dateSelected = _a.dateSelected;
                        var open = {
                            formattedTime: formattedTime,
                            value: newValue,
                            timeSelected: true
                        };
                        return __assign(__assign({}, open), (dateSelected && close));
                    }, function () {
                        _this.handleSelection({
                            onChange: onChange,
                            onTextChange: onTextChange,
                            error: error,
                            text: formattedFull,
                            date: _this.moment(newValue)
                        });
                    });
                    break;
                case 'setDay':
                    if (error || text === '') {
                        _this.setState({ formattedDate: text, open: false }, function () {
                            return _this.handleSelection({ onTextChange: onTextChange, text: text, error: error });
                        });
                    }
                    else {
                        newValue = _this.updateValue({ value: value, date: date, unit: 'day' });
                        _this.setState({ formattedDate: text, value: newValue, month: _this.getMonth(date), open: false }, function () {
                            _this.handleSelection({
                                onChange: onChange,
                                onTextChange: onTextChange,
                                error: error,
                                text: text,
                                date: _this.moment(newValue)
                            });
                        });
                    }
                    break;
                case 'setTime':
                    if (error || text === '') {
                        _this.setState({ formattedTime: text, open: false }, function () {
                            return _this.handleSelection({ onTextChange: onTextChange, text: text, error: error });
                        });
                    }
                    else {
                        newValue = _this.updateValue({ value: value, date: date, unit: 'time' });
                        _this.setState({ formattedTime: text, value: newValue, open: false }, function () {
                            _this.handleSelection({
                                onChange: onChange,
                                onTextChange: onTextChange,
                                error: error,
                                text: text,
                                date: _this.moment(newValue)
                            });
                        });
                    }
                    break;
                default:
                    break;
            }
        };
        _this.handleInputChange = function (name, value) {
            var formattedDate = _this.state.formattedDate;
            var _a = _this.props, t = _a.t, disableFuture = _a.disableFuture, disablePast = _a.disablePast, disableWeekends = _a.disableWeekends;
            var error, date, action;
            if (name === 'formattedDate') {
                action = 'setDay';
                error = t(_this.validateDate({ value: value, disableFuture: disableFuture, disablePast: disablePast, disableWeekends: disableWeekends }));
                date = _this.moment(value);
            }
            else {
                action = 'setTime';
                error = formattedDate && t(_this.validateTime({ value: formattedDate + ", " + value, disableFuture: disableFuture, disablePast: disablePast }));
                date = moment_timezone_1.default(moment_timezone_1.default().format('L') + ", " + value);
            }
            _this.handleUpdate({ action: action, payload: { date: date, error: error, text: value } });
        };
        return _this;
    }
    DateTime.getDerivedStateFromProps = function (props, state) {
        var timezone = props.timezone || moment_timezone_1.default.tz.guess();
        var value = props.value
            ? moment_timezone_1.default(props.value)
                .locale(props.lng)
                .tz(timezone)
            : undefined;
        var prevValue = state.prevValue
            ? moment_timezone_1.default(state.prevValue)
                .locale(props.lng)
                .tz(timezone)
            : undefined;
        var month = value ? ig_utils_1.getMonth(value) : ig_utils_1.getMonth(moment_timezone_1.default());
        var splitFormats = props.displayFormat ? props.displayFormat.split(',') : [];
        var dateFormat = splitFormats[0] ? splitFormats[0] : 'L';
        var timeFormat = splitFormats[1] ? splitFormats[1].trim() : 'LT';
        var formattedDate = '';
        var formattedTime = '';
        var newState = null;
        if (props.value) {
            formattedDate = moment_timezone_1.default(props.value)
                .locale(props.lng)
                .tz(timezone)
                .format(dateFormat);
            formattedTime = moment_timezone_1.default(props.value)
                .locale(props.lng)
                .tz(timezone)
                .format(timeFormat);
        }
        var resetConditions = !value && prevValue;
        if (resetConditions) {
            newState = { prevValue: undefined, value: value, formattedDate: formattedDate, formattedTime: formattedTime };
        }
        var updateFalseyValueConditions = value && !prevValue;
        if (updateFalseyValueConditions) {
            newState = { value: value, prevValue: value.toDate(), formattedTime: formattedTime, formattedDate: formattedDate, month: month };
        }
        var updateTruthyValueConditions = value && prevValue && value.format('L') !== prevValue.format('L');
        if (updateTruthyValueConditions) {
            newState = { value: value, prevValue: value.toDate(), formattedDate: formattedDate, formattedTime: formattedTime, month: month };
        }
        return newState;
    };
    DateTime.prototype.componentDidMount = function () {
        document.addEventListener('click', this.captureClick);
        var value = this.props.value;
        var _a = this.genFormat(), dateFormat = _a.dateFormat, timeFormat = _a.timeFormat;
        var _b = this.genPlaceholder(dateFormat), datePlaceholder = _b.datePlaceholder, timePlaceholder = _b.timePlaceholder;
        var month = this.getMonth(this.moment(value));
        var date;
        var formattedDate = '';
        var formattedTime = '';
        if (value) {
            var formats = this.genFormat(this.moment(value));
            formattedDate = formats.formattedDate;
            formattedTime = formats.formattedTime;
            date = this.moment(value);
        }
        this.setState({
            value: date,
            formattedDate: formattedDate,
            formattedTime: formattedTime,
            month: month,
            dateFormat: dateFormat,
            timeFormat: timeFormat,
            timePlaceholder: timePlaceholder,
            datePlaceholder: datePlaceholder
        });
    };
    DateTime.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.captureClick);
    };
    DateTime.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, highlightWeekends = _a.highlightWeekends, showYearSelector = _a.showYearSelector, label = _a.label, time = _a.time, disablePast = _a.disablePast, disableFuture = _a.disableFuture, disableWeekends = _a.disableWeekends, disabled = _a.disabled, error = _a.error, lng = _a.lng, fluid = _a.fluid, minuteStep = _a.minuteStep, reserveSpace = _a.reserveSpace, helperText = _a.helperText, indicator = _a.indicator;
        var _b = this.state, value = _b.value, month = _b.month, formattedDate = _b.formattedDate, formattedTime = _b.formattedTime, focused = _b.focused, open = _b.open, openUp = _b.openUp, timeFormat = _b.timeFormat, datePlaceholder = _b.datePlaceholder, timePlaceholder = _b.timePlaceholder;
        month.locale(this.shimLocals(lng));
        return (React.createElement("div", { className: this.genClasses({ className: className, fluid: fluid, open: open, openUp: openUp }), ref: function (ref) { return (_this.menuRef = ref); } },
            React.createElement("div", { className: "overlay-position-wrap" },
                React.createElement("div", { className: "datetime-input-wrap" },
                    React.createElement(Input_1.default, { fluid: fluid, label: label, indicator: indicator, className: "picker-input datetime-date " + (focused ? 'focused' : ''), icon: "calendar", value: formattedDate, uncontrolled: true, placeholder: datePlaceholder, onChange: this.handleInputChange.bind(this, 'formattedDate'), onFocus: this.handleFocus, onBlur: this.handleBlur, error: error, helperText: helperText, disabled: disabled, reserveSpace: reserveSpace }),
                    time && (React.createElement(Input_1.default, { fluid: fluid, reserveSpace: reserveSpace !== undefined ? reserveSpace_1.default(this.props) : true, className: "picker-input datetime-time " + (focused ? 'focused' : ''), icon: "time", value: formattedTime, uncontrolled: true, placeholder: timePlaceholder, onChange: this.handleInputChange.bind(this, 'formattedTime'), onFocus: this.handleFocus, onBlur: this.handleBlur, disabled: disabled }))),
                this.state.open && (React.createElement("div", { className: "calendar-overlay " + (reserveSpace === false ? 'unreserved' : ''), ref: function (ref) { return (_this.overRef = ref); } },
                    React.createElement(Calendar_1.default, { month: month, selected: value, reducer: this.handleUpdate, showYears: showYearSelector, highlightWeekends: highlightWeekends, disablePast: disablePast, disableFuture: disableFuture, disableWeekends: disableWeekends }),
                    time && (React.createElement(TimeOptions_1.default, { disablePast: disablePast, disableFuture: disableFuture, minuteStep: minuteStep, timeFormat: timeFormat, reducer: this.handleUpdate, value: value || moment_timezone_1.default() })))))));
    };
    DateTime.defaultProps = {
        showYearSelector: false,
        closeOnDocumentClick: true,
        closeOnSelection: true,
        minuteStep: 30
    };
    return DateTime;
}(react_1.Component));
exports.DateTime = DateTime;
exports.default = localization_1.InjectLocalization(DateTime);
